import { Button, Card, Form, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import { baseURL } from "../constants/value";
import Layout from "../components/Layout";
import moment from "moment";
import CardPensiun from "../components/CardData/CardPensiun";
import CardUmum from "../components/CardData/CardUmum";

const captchaLength = 6;
const captchaBGColor = "white";
const captchaFontColor = "black";

export function getDateFormat(date = "") {
  const mDate = moment(date);
  if (mDate.isValid()) {
    return mDate.format("DD-MM-YYYY");
  } else {
    return date;
  }
}

export default function Valid() {
  const location = useLocation();
  const [qrID, setQRID] = useState("");
  const [dataDocu, setDataDocu] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [dataError, setDataError] = useState("");
  const [tryAgain, setTryAgain] = useState(new Date().getTime());
  const [captcha, setCaptcha] = useState({
    text: "",
    isWrong: false,
    ok: false,
  });

  useEffect(() => {
    const mPathName = location.pathname;
    setQRID(mPathName);
  }, [location]);

  useEffect(() => {
    if (qrID.charAt(0) === "/") {
      setQRID(qrID.substring(1));
    }
  }, [qrID]);

  useEffect(() => {
    if (captcha?.ok) return;
    loadCaptchaEnginge(captchaLength, captchaBGColor, captchaFontColor);
  }, [captcha?.ok]);

  useEffect(() => {
    if (!qrID || !captcha?.ok) return;
    setIsLoading(true);
    fetch(baseURL + qrID)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status + " : " + response.statusText);
        }
        return response.json();
      })
      .then((jsonData) => {
        if (jsonData?.eror || jsonData?.error) {
          throw new Error(jsonData?.message);
        } else if (jsonData?.data?.nomor && jsonData?.data?.nip) {
          // Data in first child
          setDataDocu(jsonData?.data);
          setDataError("");
        } else if (jsonData?.data?.data?.nomor && jsonData?.data?.data?.nip) {
          // Data in second child
          setDataDocu(jsonData?.data?.data);
          setDataError("");
        } else if (
          jsonData?.data?.data?.data?.nomor &&
          jsonData?.data?.data?.data?.nip
        ) {
          // Data in third child
          setDataDocu(jsonData?.data?.data?.data);
          setDataError("");
        } else {
          throw new Error("Data Tidak Ditemukan!");
        }
      })
      .catch((error) => {
        setDataError(error?.message);
        console.error(error);
      })
      .finally(() => setIsLoading(false));
  }, [captcha?.ok, qrID, tryAgain]);

  function cekCaptcha() {
    if (validateCaptcha(captcha?.text) === true) {
      setCaptcha({ ...captcha, isWrong: false, ok: true, text: "" });
    } else {
      setCaptcha({ ...captcha, isWrong: true, ok: false, text: "" });
    }
    loadCaptchaEnginge(captchaLength, captchaBGColor, captchaFontColor);
  }

  return (
    <Layout>
      {dataError && !isLoading && (
        <Card
          className="text-center mx-auto glass-effect"
          style={{ maxWidth: "30rem" }}
        >
          <Card.Body>
            <Card.Text style={{ color: "red" }}>{dataError}</Card.Text>
          </Card.Body>
          <Card.Footer className="text-muted">
            <Button
              variant="warning"
              style={{ opacity: "0.9" }}
              onClick={() => setTryAgain(new Date().getTime())}
            >
              Coba Lagi
            </Button>
          </Card.Footer>
        </Card>
      )}

      {isLoading && (
        <Card
          className="text-center mx-auto glass-effect"
          style={{ maxWidth: "30rem" }}
        >
          <Card.Body>
            <Spinner animation="border" role="status" />
          </Card.Body>
        </Card>
      )}

      {!dataError && !captcha?.ok && (
        <Card
          className="text-center mx-auto glass-effect"
          style={{ maxWidth: "40rem" }}
        >
          <Card.Header>
            Masukkan captcha di bawah ini untuk menampilkan data
          </Card.Header>
          <Card.Body>
            <LoadCanvasTemplate />
            <Form.Control
              type="text"
              className="text-center mt-2"
              placeholder="..."
              value={captcha?.text}
              onChange={(e) => setCaptcha({ ...captcha, text: e.target.value })}
            />
            {captcha?.isWrong && (
              <Card.Text style={{ color: "red" }}>
                Captcha tidak sesuai!
              </Card.Text>
            )}
          </Card.Body>
          <Card.Footer className="text-muted">
            <Button
              variant="primary"
              style={{ opacity: "0.9" }}
              onClick={cekCaptcha}
            >
              Verifikasi
            </Button>
          </Card.Footer>
        </Card>
      )}

      {!dataError && captcha?.ok && !isLoading && (
        <>
          {dataDocu?.sub_layanan_pensiun ? (
            <CardPensiun dataDocu={dataDocu} />
          ) : (
            <CardUmum dataDocu={dataDocu} />
          )}
        </>
      )}
    </Layout>
  );
}
